module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isDataAvailable) ? _c('loader', {
    staticStyle: {
      "min-height": "100px"
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label text-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-label"
  }, [_vm._v(_vm._s(_vm.workflowDescription))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label text-label"
  }, [_vm._v("Complete Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-label"
  }, [_vm._v(_vm._s(_vm.completeDateComputed))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab925526"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/WorkflowInstance.vue
// module id = 984
// module chunks = 1